import { Anchor, RawHtml } from "client/Components";
import { isNotNilOrEmpty } from "client/Misc/utils";
import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import styles from "../ErrorPage.module.less";

export type SupportProps = {
	customHtml: string | nil;
	supportTelephoneNumber: string | nil;
	supportEmailAddress: string | nil;
	emailSubjectTextTemplate: LocalizationKey;
};

export const Support = (props: SupportProps): ReactElement => {
	const {
		customHtml,
		supportEmailAddress,
		supportTelephoneNumber,
		emailSubjectTextTemplate
	} = props;

	return (
		<section className={styles.section}>
			{isNotNilOrEmpty(customHtml)
				? <RawHtml html={customHtml} />
				: (
					<h2 className={styles.sectionDescription}>
						{localize("_PleaseContactSupport")}
					</h2>
				)
			}
			{isNotNilOrEmpty(supportTelephoneNumber) && (
				<p className={styles.paragraph}>
					<Anchor
						href={`tel:${supportTelephoneNumber}`}
						className={styles.phone}
					>
						{supportTelephoneNumber}
					</Anchor>
				</p>
			)}
			{isNotNilOrEmpty(supportEmailAddress) && (
				<p className={styles.paragraph}>
					<Anchor
						href={`mailto:${supportEmailAddress}?subject=${localize(emailSubjectTextTemplate)}`}
						className={styles.button}
					>
						{localize("_SendAsAnEmail")}
					</Anchor>
				</p>
			)}
		</section>
	);
};
Support.displayName = "Support";